<template>
    <modal
        v-if="popup.component"
        :show="popup.show"
        :title="popup.title"
        :needFooter="false"
        :centered="true"
        size="large"
        class="modal-identify-viewer"
        :class="className"
        bodyClass="overflowY"
        @close="onClosePopup">

            <template slot="modal-header-actions" v-if="displayPrint && !startedProcess" >
                <button type="button" title="Imprimir" @click="onPrint" class="btn btn-link min-w-auto m-0 btn-lg py-0 px-2 z-depth-0" data-dismiss="modal" aria-label="Print">
                    <i class="fas fa-print"></i>
                </button>
            </template>

            <div class="flex-column flex-fill h-100" :class="[displayPrint && !startedProcess || !displayPrint ? 'd-flex' : 'd-none']">
                <component
                    class="overflowHiddenX"
                    :is="popup.component"
                    :url="popup.url"
                    :useProxy="false"
                    @error="onInfoError"
                />
            </div>

            <div
                v-if="displayPrint"
                class="panel-control flex-column flex-fill h-100"
                :class="[startedProcess ? 'd-flex': 'd-none']">
                <div class="panel-control-content d-flex flex-column flex-fill">
                    <!-- PROCESS WORKFLOW -->
                    <print-process-workflow
                        v-if="startedProcess"
                        :description="printDescription"
                        :titleList="printTitleList"
                        :emptyResult="printEmptyResult"
                        :url="print.url.status"
                        :id="idProcess"
                        :canceled="print.canceled"
                        :showBtnClose="print.showBtnClose"
                        :titleBtnClose="print.titleBtnClose"
                        @close="onClosePrint"
                    >
                    </print-process-workflow>
                </div>
            </div>
    </modal>
</template>

<script>
    import {isObject, isEmpty} from '@config/utils'
    import GlobalMixin from '@/app/shared/mixins/global';
    import ProcessJobMixin from '@/app/shared/components/workflow/mixins/ProcessJobMixin';
    import FormViewer from '@/components/maps/shared/identify/viewers/popup/FormPropertiesViewer';

    export default
    {
        name: 'identifyInfoModal',
        mixins: [
            GlobalMixin,
            ProcessJobMixin,
        ],
        components:
        {
            Modal: () => import(/* webpackChunkName: "modal" */ '@/app/shared/components/modals/Modal'),
            PrintProcessWorkflow: () => import(/* webpackChunkName: "common-process-workflow" */ '@/app/shared/components/workflow/CommonProcessWorkflow'),
        },
        props: {
            moduleCode: {
                type: String,
                require: true,
            },
            url: {
                type: [String, Object],
                required: false
            },
            component: {
                type: Object,
                default: () => {return FormViewer},
            },
            propTitle: {
                type: String,
                default: '',
            },
            enablePrint: {
                type: Boolean,
                default: false
            },
            urlPrint: {
                type: Object,
                required: false
            },
            printDescription: {
                type: String,
                default: '',
            },
            printTitleList: {
                type: String,
                default: '',
            },
            printEmptyResult: {
                type: String,
                default: 'Não foram impressos documentos.',
            },
        },
        data() {
            return {
                popup: {
                    id: null,
                    show: false,
                    title: null,
                    baseUrl: null,
                    url: null,
                    component: null,
                    params: null,
                },
                form: {
                    inventory_number: null,
                },
                print: {
                    enable: false,
                    loading: false,
                    url: {create: null, status: null},
                    showBtnClose: true,
                    titleBtnClose: 'Voltar',
                    canceled: false,
                }
            }
        },
        mounted() {
            if(this.urlPrint) {
                this.print.url = Object.assign(this.print.url, this.urlPrint);
                this.print.enable = this.enablePrint;
            }
            this.setComponent(this.component);
            this.setBaseUrl(this.url);
        },
        created() {

        },
        beforeDestroy() {

        },
        computed: {
            baseUrl() {
                return isObject(this.popup.baseUrl) ? this.popup.baseUrl.urlObject : this.popup.baseUrl;
            },
            displayPrint() {
                return this.print.enable;
            },
            className() {
                let cls = [];
                let params = this.popup.params || {};
                if(params && params.class) {
                    cls.push(params.class);
                }
                return cls.filter(el => !!el).join(' ');
            },
        },
        methods: {
            onOpenPopup(id, url=null, forceDisablePrint=false, params={}, tools={}) {
                // FOR DINAMIC URL
                if(url){
                    this.setBaseUrl(url);
                }

                this.setConfigTools(tools);

                if(forceDisablePrint){
                    this.print.enable = false;
                }

                if(this.baseUrl){
                    let baseUrl = new String(this.baseUrl);
                    this.popup.id = id;
                    this.popup.title = this.getPopupTitle(id);
                    this.popup.url = baseUrl.toString().replace(':id', id);
                    this.popup.params = params;
                    this.popup.show = true;
                    // this.popup.component = FormViewer;
                }
            },
            onClosePopup() {
                this.popup.id = null;
                this.popup.show = false;
                this.onClosePrint();
                this.$emit('close');
            },
            getPopupTitle: function(id) {
                return isEmpty(this.propTitle) ? `${id}` : `${this.propTitle}: ${id}`;
            },
            onInfoError: function(){

            },
            setConfigTools(tools) {
                if(!!tools.print) {
                    let printTool = tools.print;
                    if(printTool.url) {
                        this.print.url = Object.assign(this.print.url, printTool.url);
                        this.print.enable = this.enablePrint;
                    }
                }
            },
            onPrint: function() {
                let id = this.popup.id;
                if(id){
                    this.startProcess(id);
                }
            },
            setLoadingPrint: function(flag){
                this.print.loading = flag;
                this.$emit('loading', flag);
            },
            resetPrint: function() {
                Object.assign(this.$data.form, this.$options.data().form);
                this.resetJob();
            },
            cancelPrint: function() {
                this.print.canceled = true;
            },
            onClosePrint: function(){
                this.cancelPrint();
                this.resetPrint();
            },
            startProcess: function(id) {
                let url = this.print.url;
                if(!(url && url.create)){
                    return;
                }

                try {
                    this.setLoadingPrint(true);

                    this.clearMessages();
                    this.$validator.validateAll().then(result => {
                        if(!result){
                            this.showError('Por favor corrija os erros no formulário');
                            return;
                        }
                        this.form.inventory_number = id;
                        this.$http.post(url.create, this.form)
                        .then( res => {
                            let data = res.data.data;
                            if(data && data.jobId){
                                this.job.id = data.jobId;
                            }else{
                                this.showError(data);
                            }
                        })
                        .catch( error => {
                            this.showHttpError(error);
                        })
                        .finally(() => this.setLoadingPrint(false))
                    });
                }
                catch(err) {
                    this.showError(err);
                }
                finally {
                    this.setLoadingPrint(false);
                }
            },
            setComponent: function(component) {
                this.popup.component = component;
            },
            setBaseUrl: function(url) {
                this.popup.baseUrl = url;
            },
        },
        watch: {
            component (value) {
                this.setComponent(value);
            },
            url (value) {
                this.setBaseUrl(value);
            },
        },
    }
</script>

<style scoped lang="scss">

</style>